// analytics
import NFA from 'shared/helpers/analytics/NFAnalytics';

//constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { REVIEW_EVENTS } from 'shared/helpers/analytics/constants/reviewEvents';

export const trackReviewImgClick = () => {
  NFA.track({
    event: REVIEW_EVENTS.REVIEW_IMAGE_CLICKED,
    type: TRACK_TYPE.EVENT,
  });
};
